import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useLocation, Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../lib/utils';
import { Button } from '../../components/ui/button';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';

// Handles both /featured/card-saved?session_id=... and /featured/card-cancel
const CardReturn = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const cancelled = location.pathname.includes('card-cancel');
  const [state, setState] = useState(cancelled ? 'cancel' : 'checking');
  const [card, setCard] = useState(null);

  useEffect(() => {
    if (cancelled) return;
    const sid = params.get('session_id');
    if (!sid) { setState('error'); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await axios.get(`${API_URL}/featured/card/status/${sid}`);
        if (r.data.saved) { setCard(r.data); setState('saved'); return; }
      } catch (e) { /* retry */ }
      if (tries++ < 5) setTimeout(poll, 1500); else setState('error');
    };
    poll();
  }, [params, cancelled]);

  return (
    <div className="min-h-screen bg-[#F7F5EF] pt-28 px-4 flex flex-col items-center text-center" data-testid="card-return">
      {state === 'checking' && (<><Loader2 className="w-8 h-8 animate-spin text-primary" /><p className="mt-3 text-gray-600">Saving your payment method…</p></>)}
      {state === 'saved' && (
        <div className="bg-white rounded-xl border p-8 max-w-md">
          <CheckCircle2 className="w-10 h-10 text-emerald-600 mx-auto mb-2" />
          <h1 className="font-serif text-2xl font-bold text-primary">Payment method saved</h1>
          <p className="text-gray-600 mt-2 text-sm">Your {card?.brand} card ending {card?.last4} is on file. <strong>$0 was charged.</strong> You can now activate your complimentary 30-day Featured placement.</p>
          <Button className="mt-4 bg-primary text-white" onClick={() => navigate('/my-featured')} data-testid="go-featured">Go to My Featured</Button>
        </div>
      )}
      {(state === 'cancel' || state === 'error') && (
        <div className="bg-white rounded-xl border p-8 max-w-md">
          <XCircle className="w-10 h-10 text-amber-500 mx-auto mb-2" />
          <h1 className="font-serif text-2xl font-bold text-primary">{state === 'cancel' ? 'Card setup cancelled' : 'Something went wrong'}</h1>
          <p className="text-gray-600 mt-2 text-sm">No card was saved and nothing was charged.</p>
          <Link to="/my-featured"><Button className="mt-4 bg-primary text-white">Back to My Featured</Button></Link>
        </div>
      )}
    </div>
  );
};

export default CardReturn;
